exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search {\r\n    height: 30px;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n.search__field {\r\n    height: 30px;\r\n    padding: 0 70px 0 10px;\r\n    width: 100%;\r\n\r\n    border: 1px solid #ccc;\r\n    border-radius: 3px;\r\n}\r\n.search__btn {\r\n    height: 30px;\r\n    padding: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 12px;\r\n    width: 60px;\r\n\r\n    border: none;\r\n    border-top-right-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n\r\n    background: #4285F4 url('/assets/img/search.svg') center center/15px 15px no-repeat;\r\n\r\n    cursor: pointer;\r\n}\r\n.search__btn:hover {\r\n    background-color: #3A77D8;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/menu/search/search.component.css
// module id = 599
// module chunks = 1